import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import AuthCallback from "@/components/AuthCallback";
import Storefront from "@/pages/Storefront";
import GuideDetail from "@/pages/GuideDetail";
import Reader from "@/pages/Reader";
import Library from "@/pages/Library";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Admin from "@/pages/Admin";
import Compare from "@/pages/Compare";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent Auth callback (session_id in URL fragment) before anything else
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Storefront />} />
        <Route path="/guides/:slug" element={<GuideDetail />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/read/:slug" element={<Reader />} />
        <Route path="/library" element={<Library />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
